<script lang="ts">
import { SelectItemType } from '@/app/common/types/selectItem.type';
import { BaseConfirm } from '@/interface/BaseConfirm.interface';
import { DPM_STATUS, DPM_STATUS_OPTIONS, OPINION } from '@/app/const';
import { ComplaintDepartmentInfo, ComplaintInfo } from '@/interface/Complaint.interface';
import { Department } from '@/interface/Department.interface';
import { masterService } from '@/services/serviceProvider';
import { ref } from 'vue';
import { BaseAlert } from '@/interface/BaseAlert.interface';

export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        header: {
            type: String,
            default: 't-action-assign-dpm'
        },
        confirmText: {
            type: String,
            default: 't-save'
        },
        cancelText: {
            type: String,
            default: 't-cancel'
        },
        complaint: {
            type: Object,
            default: {}
        },
        isReAssign: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'update:modelValue',
        'update:complaint',
        'onConfirm',
        'onCancel',
        'displayConfirmDialog',
        'displayAlertDialog'
    ],
    setup() {
        const assignDpmForm = ref();
        return { assignDpmForm };
    },
    data() {
        return {
            request: this.complaint as ComplaintInfo,
            mainResponibleDpm: this.complaint.relatedMainDepartment?.departmentCode as string | undefined,
            hasRelatedSubDpm: this.complaint.hasRelatedSubDepartment as boolean,
            originalMainOptions: [] as SelectItemType[],
            mainDepartmentOptions: [] as SelectItemType[],
            originalSubOptions: [] as SelectItemType[],
            subDepartmentOptions: [] as SelectItemType[],
            selectedSubDepartments: [] as any[],
            isCancelConfirm: false,
            dpmStatuses: DPM_STATUS_OPTIONS as SelectItemType[],
            dpmStatus: DPM_STATUS,
            rules: {
                required: (message: any) => {
                    return (v: any) => !!v || message;
                },
                requiredArray(message: any) {
                    return (v: any) => v.length > 0 || message;
                },
            },
        }
    },
    watch: {
        async dialogShow(val) {
            if (val) {
                let request = this.complaint as ComplaintInfo;
                if (this.mainDpmSelectCoordinate) {
                    this.mainResponibleDpm = undefined;
                    this.hasRelatedSubDpm = true;
                    let prevMainDpm = this.subDepartmentOptions.filter(o => o.value.toString() === request.relatedMainDepartment?.departmentCode);
                    this.selectedSubDepartments = prevMainDpm.concat(this.bindedSelectedSubDepartments);
                } else if (this.mainDpmReturn) {
                    this.mainResponibleDpm = request.relatedMainDepartment?.departmentCode as string;
                    this.hasRelatedSubDpm = request.hasRelatedSubDepartment as boolean;
                    this.selectedSubDepartments = this.bindedSelectedSubDepartments;
                    this.subDepartmentOptions = this.subDepartmentOptions.filter(o => o.value.toString() !== request.relatedMainDepartment?.departmentCode);
                } else {
                    this.mainResponibleDpm = request.relatedMainDepartment?.departmentCode as string;
                    this.hasRelatedSubDpm = request.hasRelatedSubDepartment as boolean;
                    this.selectedSubDepartments = this.bindedSelectedSubDepartments;
                }
            }
        },
        mainResponibleDpm(newVal, oldVal) {
            if (newVal) {
                this.subDepartmentOptions = this.originalSubOptions.filter(o => o.value !== newVal);
            } else {
                this.subDepartmentOptions = [...this.originalSubOptions]
            }
        },
        hasRelatedSubDpm(newVal, oldVal) {
            if (newVal === false) {
                this.selectedSubDepartments = [];
                this.assignDpmForm.resetValidation();
            }
        },
        selectedSubDepartments(newVal, oldVal) {
            let newSubDpm = this.selectedSubDepartments.map((s: any) => s.value);
            this.mainDepartmentOptions = this.originalMainOptions.filter(o => !newSubDpm.includes(o.value.toString()))
        },
    },
    async mounted() {
        await this.getDepartments();
    },
    computed: {
        dialogShow: {
            get() {
                return this.modelValue || false
            },
            set(newValue: boolean) {
                this.$emit('update:modelValue', newValue);
            }
        },
        bindedSelectedSubDepartments(): SelectItemType[] {
            const codes = this.request.relatedSubDepartments?.map((o: ComplaintDepartmentInfo) => o.departmentCode);
            return this.subDepartmentOptions.filter(o => codes?.includes(o.value.toString())) ?? [];
        },
        atLeastOneSubDepartment() {
            return this.selectedSubDepartments.length > 0
        },
        selectAllSubDepartments() {
            return this.selectedSubDepartments.length === this.subDepartmentOptions.length
        },
        allDpmEnd() {
            let result = [];
            if (this.request.relatedMainDepartment?.departmentStatus === DPM_STATUS.END)
                result.push(this.request.relatedMainDepartment.departmentCode);
            if (this.request.relatedSubDepartments?.map(o => o.departmentStatus).includes(DPM_STATUS.END)) {
                let subEnd = this.request.relatedSubDepartments.filter(o => o.departmentStatus === DPM_STATUS.END).map(m => m.departmentCode);
                if (subEnd) result = result.concat(subEnd)
            }
            return result;
        },
        mainDpmSelectCoordinate() {
            let request = this.complaint as ComplaintInfo;
            return request.relatedMainDepartment?.departmentStatus === DPM_STATUS.END
                && request.relatedMainDepartment?.staffOpinionCode === OPINION.COORDINATE
        },
        mainDpmReturn() {
            let request = this.complaint as ComplaintInfo;
            return request.relatedMainDepartment?.departmentStatus === DPM_STATUS.RETURN;
        }
    },
    methods: {
        async confirm() {
            const res = this.assignDpmForm ? await this.assignDpmForm.validate() : true;
            const valid = res.valid === undefined ? true : res.valid;
            if (valid) {
                if (this.request.relatedMainDepartment?.departmentStatus === DPM_STATUS.RETURN) {
                    let subs_end = this.request.relatedSubDepartments?.filter(o => o.departmentStatus === DPM_STATUS.END).map(m => m.departmentCode);
                    if (subs_end && subs_end?.length > 0) {
                        if (!(this.mainResponibleDpm && subs_end?.includes(this.mainResponibleDpm)) && !(this.selectedSubDepartments.length > 0 && this.selectedSubDepartments.map(o => o.value).some((r: string) => subs_end?.includes(r)))) {
                            let dpms_end = subs_end?.filter(o => o !== this.mainResponibleDpm && !this.selectedSubDepartments.map(s => s.value).includes(o));
                            this.$emit('displayAlertDialog', {
                                success: false,
                                messageTitle: `ฝ่าย ${dpms_end?.join(", ")} ที่ทำงานเสร็จแล้วจะไม่สามารถนำออกจากฝ่ายรับผิดชอบได้`,
                                messageText: `กรุณาเลือกฝ่าย ${dpms_end?.join(", ")} เพื่อทำงานในฝ่ายหลักหรือฝ่ายย่อย อย่างใดอย่างหนึ่ง`
                            } as BaseAlert)
                            return;
                        }
                    }
                }
                this.dialogShow = false;
                let confirmText = `${this.$t('t-action-assign-main-dpm-confirm')} ${this.mainResponibleDpm}`;
                if (this.selectedSubDepartments.length > 0) {
                    confirmText += ` ${this.$t('t-action-assign-sub-dpm-confirm')} ${this.selectedSubDepartments.map(o => o.value)?.join(', ')}`
                }
                this.$emit('displayConfirmDialog', {
                    messageTitle: confirmText,
                    callBack: this.onAssignDpm,
                    callBackCancel: this.onCancelConfirm
                } as BaseConfirm)
            }
        },
        onAssignDpm() {
            this.isCancelConfirm = false;
            this.$emit('update:complaint', this.request);
            this.$emit('onConfirm', {
                mainDepartmentCode: this.mainResponibleDpm,
                hasRelatedSubDepartment: this.hasRelatedSubDpm ?? false,
                relatedSubDepartments: this.selectedSubDepartments.map(o => o.value)
            });
        },
        onCancelConfirm() {
            this.isCancelConfirm = true;
            this.dialogShow = true;
        },
        cancel() {
            this.isCancelConfirm = false;
            this.dialogShow = false;
            this.$emit('onCancel');
        },
        async getDepartments() {
            const res = await masterService.getDepartments();
            const departments = res.data as Department[];
            if (departments) {
                this.originalMainOptions = departments.map(o => ({ label: this.departmentAbbr(o.code, departments), value: o.code } as SelectItemType));
                this.mainDepartmentOptions = [...this.originalMainOptions];
                this.originalSubOptions = departments.map(o => ({ label: this.departmentAbbr(o.code, departments), value: o.code } as SelectItemType));
                this.subDepartmentOptions = [...this.originalSubOptions];
            }
        },
        departmentAbbr(code: string, departments: Department[]) {
            return departments.find(o => o.code === code)?.abbr;
        },
        toggleSub() {
            if (this.selectAllSubDepartments) {
                this.selectedSubDepartments = []
            } else {
                this.selectedSubDepartments = this.subDepartmentOptions.slice();
            }
        },
        subDisabled(subDpm: string) {
            // Case 1: ฝ่ายหลักสรุปผลดำเนินการแต่เลือกต้องมีฝ่ายอื่นอีก (ล็อคฝ่ายที่ดำเนินการเสร็จแล้วทั้งหมด)
            // Case 2: ฝ่ายหลักกดส่งคืน (เปิดให้เลือกอิสระ แต่ล็อคฝ่ายที่กำลังทำงานอยู่ทั้งหมด)
            let status = this.request.relatedSubDepartments?.find(o =>
                o.departmentCode === subDpm)?.departmentStatus;
            let haveExternal = this.request.relatedSubDepartments?.find(o =>
                o.departmentCode === subDpm)?.external != null;
            return (this.mainDpmSelectCoordinate && this.allDpmEnd.includes(subDpm))
                || (this.mainDpmReturn && (status === DPM_STATUS.REQUEST_DOC
                    || status === DPM_STATUS.ASC_CONSIDER
                    || status === DPM_STATUS.UPLOADED
                    || status === DPM_STATUS.WAIT_AIRLINE
                    || (status === DPM_STATUS.IN_PROGRESS && haveExternal)
                    || status === DPM_STATUS.ACCEPTED
                ))
        },
        subShowChipStatus(subDpm: string) {
            let status = this.request.relatedSubDepartments?.find(o =>
                o.departmentCode === subDpm)?.departmentStatus;
            return status !== undefined
                && status !== DPM_STATUS.RETURN
                && status !== DPM_STATUS.IN_PROGRESS
                && status !== DPM_STATUS.END
        }
    }
}
</script>

<template>
    <v-dialog v-model="dialogShow" width="80%" :close-on-back="false" persistent>
        <v-form ref="assignDpmForm" class="admin-form app-form-input" validate-on="submit lazy"
            @submit.prevent="confirm">
            <v-card class="dialog-card">
                <v-toolbar density="compact">
                    <v-toolbar-title>{{ $t(header) }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon="mdi-close" @click="dialogShow = false"></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <v-card class="inner-card mb-6">
                        <v-toolbar density="compact">
                            <v-toolbar-title>{{ $t('t-complaint-main-responsible-dpm') }}</v-toolbar-title>
                        </v-toolbar>
                        <v-divider class="mx-4"></v-divider>
                        <v-card-text>
                            <div class="text-label">{{ $t('t-complaint-main-responsible-dpm') }}</div>
                            <v-select density="comfortable" v-model="mainResponibleDpm" class="hide-float-label"
                                variant="outlined" :label="$t('t-please-select')" hide-details="auto"
                                :items="mainDepartmentOptions" item-title="label" item-value="value"
                                :rules="[rules.required(`${$t('t-please-select')}${$t('t-complaint-main-responsible-dpm')}`)]">
                            </v-select>
                        </v-card-text>
                    </v-card>
                    <v-card class="inner-card">
                        <v-switch v-model="hasRelatedSubDpm" class="mx-4" :disabled="isReAssign"
                            :label="$t('t-complaint-has-sub-responsible-dpm')" hide-details></v-switch>
                        <v-divider class="mx-4"></v-divider>
                        <v-card-text>
                            <div class="text-label">{{ $t('t-complaint-sub-responsible-dpm') }}</div>
                            <v-select v-model="selectedSubDepartments" class="hide-float-label" variant="outlined"
                                :label="$t('t-please-select')" hide-details="auto" :items="subDepartmentOptions"
                                item-title="label" item-value="value" density="comfortable" return-object multiple
                                :disabled="!hasRelatedSubDpm" :rules="hasRelatedSubDpm ? [
                                    rules.required(`${$t('t-please-select')}${$t('t-complaint-sub-responsible-dpm')}`),
                                    rules.requiredArray(`${$t('t-please-select')}${$t('t-complaint-sub-responsible-dpm')}`)
                                ] : []">
                                <template v-slot:prepend-item>
                                    <v-list-item :title="$t('t-select-all')" @click="toggleSub">
                                        <template v-slot:prepend>
                                            <v-checkbox-btn :color="atLeastOneSubDepartment ? 'primary' : undefined"
                                                :indeterminate="atLeastOneSubDepartment && !selectAllSubDepartments"
                                                :model-value="selectAllSubDepartments">
                                            </v-checkbox-btn>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                                <template v-slot:item="{ props, item, index }">
                                    <div class="select-chips-color align-center">
                                        <v-list-item v-bind="props" height="2000"
                                            :disabled="subDisabled(item.raw.value.toString())">
                                            <template v-slot:prepend>
                                                <v-checkbox :value="item.raw" :model-value="selectedSubDepartments"
                                                    color="primary" density="compact" hide-details>
                                                </v-checkbox>
                                            </template>
                                            <template v-slot:title="{ title }">
                                                <span class="mr-2">{{ item.raw.label }}</span>
                                                <v-chip density="compact" class="app-chip"
                                                    v-if="subDisabled(item.raw.value.toString())">
                                                    {{ $t('t-action-summary-disabled') }}
                                                </v-chip>
                                                <v-chip density="compact" class="app-chip"
                                                    v-else-if="subShowChipStatus(item.raw.value.toString())"
                                                    :color="dpmStatuses.find(o => o.value === request.relatedSubDepartments?.find(o =>
                                                        o.departmentCode === item.raw.value)?.departmentStatus)?.color">
                                                    {{$t(`t-${dpmStatuses.find(o => o.value ===
                                                        request.relatedSubDepartments?.find(o =>
                                                            o.departmentCode === item.raw.value)?.departmentStatus)?.label}`)}}
                                                </v-chip>
                                            </template>
                                        </v-list-item>
                                    </div>
                                </template>
                            </v-select>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-container class="mx-0">
                        <div class="d-flex justify-end">
                            <v-btn @click="cancel" variant="outlined" color="primary" size="large">
                                {{ $t(cancelText) }}
                            </v-btn>
                            <v-btn @click="confirm" variant="flat" color="primary" size="large">
                                {{ $t(confirmText) }}
                            </v-btn>
                        </div>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>